<template>
    <div id="down-main-page">
        <div class="top_part">
            <img class="top_part_back" src="@/assets/download/newback.png" alt="">
            <!-- <img class="top_logo" src="@/assets/download/back-logo.png" alt="">
            <h1><br/>网格量化工具</h1>
            <h2>克服投资情绪<br/>轻松穿越牛熊</h2> -->
        </div>
        <!-- <div class="contact">*iOS用户需用海外Apple ID下载，如有问题请</div> -->
        <div class="contact mb-117">
            <span>邮件联系客服：{{ email }}</span>
            <span class="copy my_code" @click="copy">
                <img src="@/assets/download/copy.png">
            </span>
        </div>
        <div class="button_box">
            <!-- <button @click="iosProDown('store')">
                <img src="@/assets/download/apple.png" alt="">
                <span>Appstore<br/><span class="little">(需要海外ID)</span></span>
            </button> -->
            <button @click="iosProDown">
                <img src="@/assets/download/apple.png" alt="">
                <span>Testflight</span>
                <!-- <br/><span class="little">(需要海外ID)</span> -->
            </button>
            <button @click="androidDown">
                <img src="@/assets/download/and.png" alt="">
                <span>Android</span>
            </button>
        </div>
        <div id="mask" v-show="maskViewShow" @click="maskViewShow = false">
            <span class="mask-tip">请在浏览器中打开</span>
            <img src="@/assets/down/tip_arrow.png"/>
        </div>
        <jgz-loading :loading-show='showLoading'></jgz-loading>
        <div class="alert" v-show="alertShow">
            <span>{{message}}</span>
        </div>
    </div>
</template>

<script>
import JgzLoading from '@/components/JgzLoading.vue'
import Clipboard from 'clipboard'
export default {
    name: 'DownloadFromFxh',
    data() {
        return {
            maskViewShow: false,
            iosUrl: '',
            androidUrl: '',
            alertShow: false,
            message: '',
            email: 'jinguozi007@gmail.com',
            showLoading: true,
        }
    },
    components: {
        JgzLoading,
    },
    mounted() {
        // const script = document.createElement('script')
        // script.src = 'https://s9.cnzz.com/z_stat.php?id=1278708975&web_id=1278708975'
        // script.language = 'JavaScript'
        // document.body.appendChild(script)
        this.getDownUrl();
    },
    watch: {
        $route() {
            if (window._czc) {
                let location = window.location
                let contentUrl = location.pathname + location.hash
                let refererUrl = '/'
                window._czc.push(['_trackPageview', contentUrl, refererUrl])
            }
        }
    },
    methods: {
        copy() {
            let str = this.email
            let clipboard = new Clipboard('.my_code', {
                text: function () {
                    return str
                }
            })
            console.log(clipboard)
            clipboard.on('success', e => {
                this.showAlert('复制成功')
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                this.showAlert('复制失败，请长按邀请码进行复制')
                clipboard.destroy()
            })
        },
        showAlert(message) {
            this.message = message;
            this.alertShow = true;
            setTimeout(() => {
                this.alertShow = false;
            }, 1500);
        },

        getDownUrl() {
            this.$MyAxios.get('/api/versions/downloadUrl', {}, response => {
                if(response.code == 1) {
                    this.showLoading = false;
                    this.iosUrl = response.data.ios;
                    this.androidUrl = response.data.android;
                }
            })
        },

        
        // 安卓交易版本下载
        androidDown() {
            let isWeChat =  /MicroMessenger/.test(navigator.userAgent);
			if(isWeChat){
				this.maskViewShow = true;
			}else{
                if(window._czc) {
                    window._czc.push(['_trackEvent', '非小号', 'APP下载', '安卓下载'])
                }
				var iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.src = "javascript: '<script>location.href=\"" + this.androidUrl + "\"<\/script>'";                
                // let url = "https://test.misc.jinguozi.net/JGZ.apk"                          //  交易版URL
				// iframe.src = "javascript: '<script>location.href=\"" + url + "\"<\/script>'";
                document.getElementsByTagName('body')[0].appendChild(iframe);
			}
        },

        //  testflight普通版本下载
        iosDown() {
            let isWeChat =  /MicroMessenger/.test(navigator.userAgent);
			if(isWeChat){
				this.maskViewShow = true;
			}else{
                // window.location.href = 'itms-services://?action=download-manifest&url=https://down.jgz.com/mainifest.plist';
                window.location.href = `http://www.ggsign123.com/app_merge/jinguozi`;
			}
        },

        //  testflight交易版本下载
        iosProDown(tag) {
            // return
            let isWeChat =  /MicroMessenger/.test(navigator.userAgent);
			if(isWeChat){
				this.maskViewShow = true;
			}else{
                // window.location.href = `https://testflight.apple.com/join/TO7aMQTq`;
                // window.location.href = this.iosUrl;
                if(tag === 'store') {
                    if(window._czc) {
                        window._czc.push(['_trackEvent', '非小号', 'APP下载', 'iOS AppStore下载'])
                    }
                    window.open('https://apps.apple.com/us/app/%E9%87%91%E6%9E%9C%E5%AD%90%E4%B8%93%E4%B8%9A%E7%89%88/id1602327889?l=zh')
                }else{
                    // this.$router.push({ path: 'user-guide-fromfxh' })
                    window.location.href = this.iosUrl;
                }
			}
        },

        //  本地服务器版本下载
        iosServerDown() {
            let isWeChat =  /MicroMessenger/.test(navigator.userAgent);
			if(isWeChat){
				this.maskViewShow = true;
			}else{
                window.location.href = `itms-services://?action=download-manifest&url=${this.iosUrl}`;
			}
        },
    }
}
</script>

<style lang='less'>
#down-main-page {
    min-height: 100vh;
	width: 100%;
	background: linear-gradient(180deg,#fff6e8, #ffffff);
	background-size: 100% 100%;
	background-repeat: no-repeat;
    position: relative;
    img {
        pointer-events: none;
    }
    .top_part {
        width: 100%;
        height: 654px;
        // margin-bottom: 80px;
        margin-bottom: 60px;
        .top_part_back {
            width: 100%;
            height: 654px;
            position: relative;
            overflow: hidden;
        }
        .top_logo {
            height: 163px;
            width: 306px;
            left: 26px;
            top: 84px;
            position: absolute;
            z-index: 1;
        }
        h1 {
            height: 138px;
            width: 288px;
            line-height: 71px;
            font-size: 48px;
            font-weight: 600;
            color: #ffffff;
            position: absolute;
            top: 181px;
            left: 57px;
            text-align: left;
        }
        h2 {
            height: 118px;
            width: 240px;
            line-height: 62px;
            font-size: 40px;
            font-weight: 400;
            color: #ffffff;
            position: absolute;
            top: 353px;
            left: 57px;
            text-align: left;
        }
    }
    .contact {
        font-size: 28px;
        margin-bottom: 20px;
        line-height: 40px;
        &.mb-117 {
            margin-bottom: 77px;
        }
        span {
            vertical-align: middle;
            margin-right: 20px;
        }
        img {
            vertical-align: middle;
            width: 40px;
            height: 40px;
        }
    }
    .button_box {
        position: relative;
    }
    button {
        height: 88px;
        width: 600px;
        outline: none;
        border: none;
        cursor: pointer;
        border-radius: 8px;
        background: #FF811F;
        // box-shadow:0px 6px 16px rgba(255,102,0,0.3);
        // position: absolute;
        margin-bottom: 40px;
        color: #ffffff;
        font-size: 32px;
        font-weight: bold;
        &:nth-of-type(1) {
            left: 40px;
        }
        // &:nth-of-type(2) {
        //     left: 50%;
        //     transform: translateX(-50%);
        // }
        &:nth-of-type(2) {
            right: 40px;
            // font-size: 26px;
        }
        &.disable {
            background: gray;
        }
        img {
            width: 48px;
            height: 48px;
            vertical-align: middle;
            margin-right: 20px;
        }
        span {
            vertical-align: middle;
            text-align: center;
            display: inline-block;
            font-size: 28px;
            font-weight: bold;
            .little {
                font-size: 20px;
                font-weight: normal;
            }
        }
    }
    .alert {
        position: fixed;
        z-index: 3;
        top: 40%;
        left: 50%;
        height: 60px;
        width: auto;
        padding: 0 30px;
        transform: translateX(-100px);
        border-radius: 8px;
        background: rgba(0, 0, 0, .9);
        color: #ffffff;
        line-height: 60px;
    }
}
@keyframes moveLeft
{
	0% {left: 0vw;}
    50% {left: -200vw;}
    100% {left: 0vw;}
}

@-webkit-keyframes moveLeft /*Safari and Chrome*/
{
	0% {left: 0vw;}
    50% {left: -200vw;}
    100% {left: 0vw;}
}

@keyframes moveRight
{
	from {left: -200vw;}
	to {left: 0px;}
}

@-webkit-keyframes moveRight /*Safari and Chrome*/
{
	from {left: -200vw;}
	to {left: 0px;}
}
</style>
